import { ResponseError } from "../Repository/eventbookyapi/runtime";

// Must match SubscriptionExpiredException.ErrorMessage in the API.
const SubscriptionExpiredMessage = "SubscriptionExpired";

/**
 * True when the API rejected the request because the company's subscription is past its
 * grace period (adding new members is blocked until it is renewed).
 */
export const isSubscriptionExpiredError = async (error: unknown): Promise<boolean> => {
    if (error instanceof ResponseError) {
        const body = await error.response.clone().json().catch(() => null);
        return body?.message === SubscriptionExpiredMessage;
    }
    return false;
};
